import { CommonResponseModel } from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";
export class EmployeeHodServices extends CommonAxiosService {
    private URL = "/employee_hod_mapping";

    async getAllEmployeeHodMapping(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + "/getAllEmployeeHod")
    }
}